import React, { useState, useEffect } from "react";
import withApi from "../../higherOrderComponents/withApi";

export const PriceRules = withApi(({ api, productId }) => {
  const [rules, setRules] = useState(null);
  const [editing, setEdit] = useState(null);
  const [editedPrice, setPrice] = useState(null);
  const [editedFrom, setFrom] = useState(null);
  const [editedTo, setTo] = useState(null);
  const [editedPriority, setPriority] = useState(null);
  const [editedDuration, setDuration] = useState(null);
  const [editedDays, setDays] = useState(null);
  const [editedStartDate, setStartDate] = useState(null);
  const [editedEndDate, setEndDate] = useState(null);
  const [editedResourceMatch, setResourceMatch] = useState(null);

  useEffect(() => {
    async function loadFromApi() {
      const loadedRules = await api.products.getPriceRules(productId);
      setRules(loadedRules);
    }

    if (!rules) {
      loadFromApi();
    }
  });

  // The backend refuses a rule with a price <= 0, From after To, StartDate after
  // EndDate or a duration <= 0 (400 with the reason); without this the click
  // silently did nothing.
  const reportFailure = (action, e) => {
    alert(`Unable to ${action} the rule. ${e?.payload?.translatedMessage || e?.message || ''}`.trim());
  };

  const formatDate = (date) => {
    if (date == null) {
      return null;
    }
    const parsedDate = new Date(date);

    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    const hour = String(parsedDate.getHours()).padStart(2, '0');
    const minute = String(parsedDate.getMinutes()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;

    return formattedDate;
  }

  if (rules === null) {
    return <React.Fragment>Loading...</React.Fragment>;
  }

  return (
    <React.Fragment>
      <button
        type="button"
        className="button button-color-primary button-shrink-limited"
        onClick={async () => {
          try {
            await api.products.addRule({
              price: 999.0,
              from: null,
              to: null,
              priority: 0,
              durationInSeconds: null,
              dayOfWeekFlag: null,
              resourceMatch: null,
              startDate: null,
              endDate: null,
              productId,
            });
          } catch (e) {
            reportFailure('add', e);
            return;
          }
          const loadedRules = await api.products.getPriceRules(productId);
          setRules(loadedRules);
        }}
      >
        New
      </button>

      <br></br>
      <br></br>

      <table className="data-lists component-data-table cell-content-align-top data-table-no-results">
        <tr style={{ backgroundColor: "#5e5e5e", color: "#f1f1f3" }}>
          <td>Price</td>
          <td>From</td>
          <td>To</td>
          <td>Priority</td>
          <td>Duration In Minutes</td>
          <td>Days Of Week</td>
          <td>Resource Match</td>
          <td>Start Date</td>
          <td>End Date</td>
          <td></td>
          <td></td>
        </tr>
        {rules.map((whole) => {
          const {
            id,
            price,
            from,
            to,
            priority,
            durationInSeconds,
            dayOfWeekFlag,
            resourceMatch,
            startDate,
            endDate,
          } = whole;

          if (editing == id) {
            return (
              <tr>
                <td>
                  <input
                    style={{ width: "60px" }}
                    type="text"
                    value={editedPrice}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setPrice(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "100px" }}
                    type="text"
                    value={editedFrom}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setFrom(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "100px" }}
                    type="text"
                    value={editedTo}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setTo(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "50px" }}
                    type="number"
                    value={editedPriority}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setPriority(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "80px" }}
                    type="number"
                    value={editedDuration}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setDuration(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <span>
                    {["m", "t", "w", "t", "f", "s", "s"].map((day, index) => (
                      <span
                        onClick={() => {
                          setDays(editedDays ^ Math.pow(2, index));
                        }}
                        style={{
                          fontWeight:
                            editedDays & Math.pow(2, index) ? "800" : "100",
                          marginRight: "5px",
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      >
                        {day}
                      </span>
                    ))}
                  </span>
                </td>
                <td>
                  <input
                    type="text"
                    value={editedResourceMatch}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setResourceMatch(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    type="datetime-local"
                    value={editedStartDate}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setStartDate(e.target.value == "" ? null : e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    type="datetime-local"
                    value={editedEndDate}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setEndDate(e.target.value == "" ? null : e.target.value);
                    }}
                  ></input>
                </td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEdit(null);
                  }}
                >
                  Cancel
                </td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    try {
                      await api.products.editRule(
                        // A copy: on a refusal the row must keep its saved values.
                        Object.assign({}, whole, {
                          price: editedPrice,
                          from: editedFrom,
                          to: editedTo,
                          priority: editedPriority,
                          durationInSeconds: editedDuration * 60 || undefined,
                          dayOfWeekFlag: editedDays,
                          resourceMatch: editedResourceMatch,
                          startDate: editedStartDate,
                          endDate: editedEndDate,
                        })
                      );
                    } catch (e) {
                      reportFailure('save', e);
                      return;
                    }
                    const loadedRules = await api.products.getPriceRules(
                      productId
                    );
                    setEdit(null);
                    setRules(loadedRules);
                  }}
                >
                  Save
                </td>
              </tr>
            );
          }

          return (
            <tr>
              <td>{price}</td>
              <td>{from}</td>
              <td>{to}</td>
              <td>{priority}</td>
              <td>{durationInSeconds / 60 || ""}</td>
              <td>
                <span>
                  {dayOfWeekFlag
                    ? ["m", "t", "w", "t", "f", "s", "s"].map((day, index) => (
                        <span
                          style={{
                            fontWeight:
                              dayOfWeekFlag & Math.pow(2, index)
                                ? "800"
                                : "100",
                            marginRight: "5px",
                            fontSize: "20px",
                          }}
                        >
                          {day}
                        </span>
                      ))
                    : ""}
                </span>
              </td>
              <td>{resourceMatch}</td>
              <td>{formatDate(startDate)}</td>
              <td>{formatDate(endDate)}</td>
              <td
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  const result = confirm("Are you sure to delete this rule ?");
                  if (!result) {
                    return;
                  }
                  try {
                    await api.products.deleteRule(id);
                  } catch (e) {
                    reportFailure('delete', e);
                    return;
                  }
                  const loadedRules = await api.products.getPriceRules(
                    productId
                  );
                  setRules(loadedRules);
                }}
              >
                Delete
              </td>
              <td
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEdit(id);
                  setPrice(price);
                  setFrom(from);
                  setTo(to);
                  setPriority(priority);
                  setDuration(durationInSeconds/60);
                  setDays(dayOfWeekFlag);
                  setResourceMatch(resourceMatch);
                  setStartDate(startDate);
                  setEndDate(endDate);
                }}
              >
                Edit
              </td>
            </tr>
          );
        })}
      </table>
    </React.Fragment>
  );
});
